import Vue from 'vue'
import { CatalogItem } from 'services/api-service'

export interface RegistrationInfo {
  registerFor: 'answer' | 'reply'
  stagedContentToken: string
}

export interface ConfirmedSubmitInfo {
  catItem: CatalogItem
  questionId?: number
  siteKey: string
  ugcType: 'answer' | 'reply'
}

export interface ISubmissionContext {
  answerText?: string
  confirmedSubmitComplete(info: ConfirmedSubmitInfo): void
  emailSubmitComplete(ugcType: 'answer' | 'reply'): void
  eventBus: Vue
  iqrlId?: number // itemQuestionRecipientLogId
  showRegistration(registrationInfo: RegistrationInfo): void
  showError(message: string, endFlow: boolean, autoClosePopover: boolean): void
}

export class SubmissionContext implements ISubmissionContext {
  constructor() {
    this.eventBus = new Vue()
  }

  answerText // from inbox submission
  iqrlId
  eventBus: Vue

  confirmedSubmitComplete(info: ConfirmedSubmitInfo) {
    this.eventBus.$emit('confirmedSubmitComplete', info)
  }

  emailSubmitComplete(ugcType: 'answer' | 'reply') {
    this.eventBus.$emit('emailSubmitComplete', ugcType)
  }

  showRegistration(registrationInfo: RegistrationInfo) {
    this.eventBus.$emit('showRegistration', registrationInfo)
  }

  showError(message: string, endFlow = false, autoClose = true) {
    this.eventBus.$emit('showError', message, endFlow, autoClose)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/components/answers/answer-reply-submission-context.ts